export default __webpack_public_path__ + "static/media/Sig3.c26b4e7b.png";